angular.module('hotPointDetailLineModule', [])
    .directive('lineChartDir', ['$q', 'initHotHead', '$timeout', 'trsHttpService', function($q, initHotHead, $timeout, trsHttpService) {
    // Runs during compile
    return {
        restrict: 'E',
        replace: true,
        template: "<div ng-style=\"myStyle\" ng-click=\"request(params)\"></div>",
        scope: {
            optionJsons: "="
        },
        link: function(scope, iElement, iAttrs) {
            $timeout(function() {
                scope.myStyle = {
                    height: '300px',
                    width: '100%'
                };
                if(scope.optionJsons=== '') return;
                var option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        x: 'right', // 'center' | 'left' | {number},
                        y: 'top', // 'center' | 'bottom' | {number}
                        data:[{name:'报道量',textStyle:{ color:'#d64541'}},{name:'增量',textStyle:{ color:'#A7D265'}}]
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    title: {
                        text: '',
                        subtext: ''
                    },
                    calculable: true,
                    animation: false,
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: scope.optionJsons.hour
                    },
                    yAxis: [
                        {
                           name:"报道量",
                           type:"value",
                           splitNumber: 5
                        },
                        {
                            name:"增量",
                            type:"value",
                            axisLabel: {
                                formatter: function(r) {
                                    //判断是否为小数  如果是  不显示
                                    var reg = /^[+-]?[1-9]?[0-9]*\.[0-9]*$/;
                                    if (!reg.test(r))
                                        return r;
                                }
                            },
                            splitLine: { show: false },
                        }
                    ],
                    series: [
                        {
                            name:'报道量',
                            type:'line',
                            itemStyle : {
                                normal : {
                                    lineStyle:{
                                        color:'#d64541'
                                    }
                                }
                            },
                            data:scope.optionJsons.value
                        },
                        {
                            name:'增量',
                            type:'line',
                            yAxisIndex: 1,
                            itemStyle : {
                                normal : {
                                    lineStyle:{
                                        color:'#A7D265'
                                    }
                                }
                            },
                            data:scope.optionJsons.rate
                        }
                    ]
                };

                require(['echarts'], function(echarts) {
                    var myChart = echarts.init(iElement[0]);
                    myChart.setOption(option);
                    window.onresize = myChart.resize;
                 });
            }, 500);
        }
    };
}]);